import {getCurrentUserLogin, isLoggedIn} from '@github-ui/client-env'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {sendEvent} from '@github-ui/hydro-analytics'
import {cleanVariables} from '@github-ui/relay-query-cache/helpers'
import {createSafeIndexedDbPersister, SIMPLE_VALIDATOR} from '@github-ui/safe-indexed-db-storage'
import {getIssueIndexPageQueryDefaultValues} from '@github-ui/issue-index-query-defaults'

// Query metadata for Issue Index (from IssueIndexPageQuery.graphql.ts)
const ISSUE_INDEX_QUERY_NAME = 'IssueIndexPageQuery'

const DEFAULT_TTL = 1000 * 60 * 60 * 24 // 24 hours

export class LegacyIssuesIndexPreheat {
  #storage: ReturnType<typeof createSafeIndexedDbPersister>

  constructor() {
    this.#storage = createSafeIndexedDbPersister({
      validator: SIMPLE_VALIDATOR,
      sendAnalyticsEvent: (eventType, target?, payload = {}) => {
        sendEvent(eventType, {...payload, target})
      },
    })
  }

  async preheat(owner: string, repo: string, source: string): Promise<void> {
    if (isFeatureEnabled('disable_preheating_for_issues') || !isLoggedIn()) return

    const variables = cleanVariables(
      {
        owner,
        name: repo,
      },
      getIssueIndexPageQueryDefaultValues({owner, repo}),
    )
    const currentUserLogin = getCurrentUserLogin()
    const cacheKey = `relay-query-${currentUserLogin}-${ISSUE_INDEX_QUERY_NAME}#${JSON.stringify(variables)}`

    const cachedQuery = await this.#storage.getItem(cacheKey)
    if (cachedQuery) return

    const response = await fetch(`/${owner}/${repo}/issues/preheat/index?source=${source}`, {
      headers: {
        Accept: 'application/json',
        'X-GITHUB-PREHEAT': source,
      },
    })

    if (response.status === 200) {
      const payload = await response.json()
      const ttl = payload.cacheValue.state.data.ttl || DEFAULT_TTL
      await this.#storage.setItem(cacheKey, payload.cacheValue, Date.now(), ttl, {
        preheat_source: source,
        update_type: 'pre_heated',
      })
    }
  }
}
